import { HTTP } from "../../../http-common";
import { createHelpers } from "vuex-map-fields";
import { ratePlan } from "../../../models/ratePlan";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "../../../models/httpError";

export const { mapFields: mapRatePlanFields } = createHelpers({
  getterType: `ratePlan/getField`,
  mutationType: `ratePlan/updateField`,
});

const state = {
  rows: [],
  count: 0,
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setRatePlan(state, ratePlan) {
    state.rows = ratePlan.data;
    state.count = ratePlan.count;
  },
  setProgress(state, message) {
    state.message = message;
  },
  addRow(state) {
    state.rows.push(new ratePlan());
  },
  updateRatePlan(state, { index, ratePlan }) {
    state.rows.splice(index, 1, ratePlan);
  },
  addRatePlan(state, rateplan) {
    state.rows.push(rateplan);
  },
  removeRatePlan(state, id) {
    if (state.rows.length > 0) {
      for (var index = state.rows.length; index--; ) {
        if (state.rows[index].id === id) {
          state.rows.splice(index, 1);
        }
      }
    }
  },
  updateField,
};

//ACTIONS
const actions = {
  async getRatePlans({ commit, dispatch }, request) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        `support/getRatePlans/${
          request && request.archived ? request.archived : false
        }`,
        request && request.filter ? request.filter : {}
      );
      response
        .then(function(data) {
          var resultData = data.data;
          commit("setRatePlan", resultData);

          dispatch(
            "setMessage",
            new httpError({ message: "Rateplans Retrieved", httpStatus: 200 })
          );
          resolve(resultData);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeRatePlan({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      var response = HTTP.delete("support/DeleteRatePlan/" + id);
      response
        .then(function() {
          commit("removeRatePlan", id);
          dispatch(
            "setMessage",
            new httpError({ httpStatus: 200, message: "deleted OK" })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error deleting ratePlan :" + err,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },

  saveRatePlans({ state, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post("support/UpdateRatePlans/", state.rows);
      response
        .then(function(data) {
          var resultData = data.data;
          commit("setRatePlan", resultData);
          dispatch(
            "setMessage",
            new httpError({ httpStatus: 200, message: "Updated OK" })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error updating ratePlan :" + err,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  saveRatePlan({ state, commit, dispatch }, editedPlan) {
    return new Promise((resolve, reject) => {
      if (editedPlan.id > 0) {
        var i = state.rows.map((r) => r.id).indexOf(editedPlan.id);
        var payload;
        if (i > -1) payload = state.rows[i];
        else {
          reject();
          return;
        }
      } else payload = editedPlan;
      

      HTTP.post("support/UpdateRatePlan/", payload)
        .then(function(data) {
          var resultData = data.data;
          if (resultData.length > 0) {
            var i = state.rows.map((r) => r.id).indexOf(resultData[0].id);
            if (i >= 0) {
              commit("updateRatePlan", { index: i, ratePlan: resultData[0] });
            } else {
              commit("addRatePlan", resultData[0]);
            }
          }
          dispatch(
            "setMessage",
            new httpError({ httpStatus: 200, message: "Rateplan Updated!" })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error updating ratePlan :" + err,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
